<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
          </div>
          <!--<div class="queryItem">-->
            <!--<label>库存日期:</label>-->
            <!--<lk-DatePicker class="item" v-model="query.queryDate" :options="disableFromNow" :editable="false" clearable></lk-DatePicker>-->
          <!--</div>-->
          <div class="queryItem">
            <label>入库时间:</label>
            <timeStampDatePicker   v-model='query.startTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker   v-model='query.endTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix" ></goodsSearchItem>
            <!-- <label>商品编码:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input> -->
          </div>
          <!-- <div class="queryItem">
            <label>商品通用名称:</label>
            <goods-select  class="item"
              v-model="query.goodsIds"></goods-select>

          </div> -->
          <div class="queryItem">
            <label>不动销天数:</label>
            <div class="daysSpan-wrap">
              <lk-input-number
               :min="0" :step="1" v-model="query.noSaleBeginDays" :precision="0"
              ></lk-input-number>
              至
              <lk-input-number
                :min="0" :step="1" v-model="query.noSaleEndDays" :precision="0"
              ></lk-input-number>
            </div>
          </div>
           <!-- <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for='(item ,i) in getGoodsOrigin' :key="i" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div> -->
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false,getTotal)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap btn">
          <exportAsync class="mr" @on-click='handleExport' v-if="handlePermission('nonmovingDecisionAnalysisExport')"></exportAsync>
          <lk-button type="primary" class="mr" @click='refreshTime'>刷新今日报表</lk-button>
          <div v-if="deadline">数据截止至 {{deadline}}</div>
        </div>

        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">库存数量:</div>
            <div class="Report-total-item-value">{{total.num}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税库存金额:</div>
            <div class="Report-total-item-value">{{total.amount}}</div>
          </div>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
// import goodsService from '@/services/goods';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import reportMixin from './reportMixin';
import reportService from '../../services/report';
import exportAsync from '../../components/report/ExportAsync.vue';

export default {
  name: 'nonmovingDecisionAnalysisList',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame, exportAsync,
  },
  data() {
    return {
      deadline: '',
      query: {
        storeIds: [],
        goodsIds: [],
        goodsSerialCode: '',
        startTime: null,
        endTime: null,
        noSaleBeginDays: null,
        noSaleEndDays: null,
      },
      total: {},
      disableFromNow: {
        disabledDate(date) {
          // 最高支持查询最近120天前报表
          const last120Day = new Date();
          last120Day.setDate(last120Day.getDate() - 120);
          return date && (date.valueOf() > Date.now() || date.valueOf() < last120Day.getTime());
        },
      },
      columns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '业务机构',
          key: 'storeCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'storeName',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'goodsSerialCode',
          minWidth: 116,
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'goodsApprovedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116,
        },
        {
          title: '包装单位',
          key: 'pkgUnitName',
          minWidth: 116,
        },
        {
          title: '生产企业',
          key: 'producer',
          minWidth: 116,
        },
        {
          title: '第一次入库日期',
          key: 'firstWarehousingTime',
          minWidth: 116,
        },
        {
          title: '最后一次销售日期',
          key: 'lastSaleTime',
          minWidth: 116,
        },
        {
          title: '不动销天数',
          key: 'noSalesDayNum',
          minWidth: 116,
        },
        {
          title: '不动销区间',
          key: 'noSalesInterval',
          minWidth: 116,
        },
        {
          title: '货龄',
          key: 'goodsAge',
          minWidth: 116,
        },
        {
          title: '货龄区间',
          key: 'goodsAgeInterval',
          minWidth: 116,
        },
        {
          title: '库存数量',
          key: 'inventoryNum',
          minWidth: 116,
        },
        {
          title: '含税库存金额',
          key: 'inventoryAmountString',
          minWidth: 116,
        },
        {
          title: '不含税库存金额',
          key: 'inventoryAmountWithoutTaxString',
          minWidth: 116,
        },
        {
          title: '不含税金额占比',
          key: 'inventoryAmountWithoutTaxRatio',
          minWidth: 116,
        },
      ],
      tableData: [],
      goodsLoading: false,
      goodsList: [],
    };
  },
  methods: {
    refreshTime() {
      this.$store.commit('setDisableLoading', true);
      reportService.nonmovingDecisionRefresh()
        .then((res) => {
          const data = res.data;
          if (data.status == 200) {
            if (data.data.success) {
              this.getRefreshTime();
              this.handleSearch(true, this.getTotal);
            } else {
              this.$Message.error(data.data.message);
            }
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getRefreshTime() {
      this.$store.commit('setDisableLoading', true);
      reportService.getNonmovingDecisionRefresh()
        .then((res) => {
          if (res.data.status == 200) {
            this.deadline = res.data.data.refreshTimeStr;
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleExport(info, func) {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      reportService.nonmovingDecisionAnalysisExport(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          func(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getTotal() {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      reportService.nonmovingDecisionAnalysisTotal(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        storeIds: [],
        goodsIds: [],
        goodsSerialCode: '',
        startTime: null,
        endTime: null,
        noSaleBeginDays: null,
        noSaleEndDays: null,
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();

      reportService.nonmovingDecisionAnalysis(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.firstWarehousingTime = result.firstWarehousingTime ? utils.formatTime(result.firstWarehousingTime, 'YYYY-MM-DD') : '';
            result.lastSaleTime = result.lastSaleTime ? utils.formatTime(result.lastSaleTime, 'YYYY-MM-DD') : '';
            this.tableData.push(result);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // fetchGoods(query) {
    //   if (query !== '') {
    //     const data = {
    //       nameMix: query,
    //       page: 1,
    //       size: 5,
    //     };
    //     this.goodsLoading = true;
    //     this.$store.commit('setDisableLoading', true);
    //     goodsService.listGoodsBases(data).then((res) => {
    //       if (res.data.status === 200 && res.data.data.list.length) {
    //         this.goodsList = res.data.data.list;
    //       } else if (res.data.error) {
    //         this.$Message.error(res.data.error);
    //       }
    //       this.goodsLoading = false;
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    //   } else {
    //     this.goodsList = [];
    //   }
    // },
  },
  mounted() {
    this.handleSearch(true, this.getTotal);
    this.getRefreshTime();
  },
};
</script>
